import { render, staticRenderFns } from "./InstituteDetails.vue?vue&type=template&id=f9e8ea76&scoped=true&"
import script from "./InstituteDetails.vue?vue&type=script&lang=js&"
export * from "./InstituteDetails.vue?vue&type=script&lang=js&"
import style0 from "./InstituteDetails.vue?vue&type=style&index=0&lang=css&"
import style1 from "./InstituteDetails.vue?vue&type=style&index=1&id=f9e8ea76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9e8ea76",
  null
  
)

export default component.exports